import { Wrench, SealCheck, WarningCircle, ShieldCheck } from "@phosphor-icons/react";
import { fmtDate } from "../lib/date";

const MAINT = {
  up_to_date: { cls: "bg-emerald-100 text-emerald-900 border-emerald-500", label: "Up to Date" },
  due_soon: { cls: "bg-amber-100 text-amber-900 border-amber-500", label: "Service Due Soon" },
  due: { cls: "bg-orange-200 text-orange-900 border-orange-500", label: "Service Due" },
  overdue: { cls: "bg-red-600 text-white border-red-800", label: "Service Overdue" },
};
const MOT = {
  valid: { cls: "bg-emerald-100 text-emerald-900 border-emerald-500", label: "Valid" },
  expiring: { cls: "bg-amber-100 text-amber-900 border-amber-500", label: "Expiring" },
  expired: { cls: "bg-red-600 text-white border-red-800", label: "Expired" },
  unknown: { cls: "bg-slate-100 text-slate-600 border-slate-300", label: "Unknown" },
};
const TAX = {
  taxed: { cls: "bg-emerald-100 text-emerald-900 border-emerald-500", label: "Valid" },
  due_soon: { cls: "bg-amber-100 text-amber-900 border-amber-500", label: "Due" },
  untaxed: { cls: "bg-red-600 text-white border-red-800", label: "Untaxed" },
  sorn: { cls: "bg-slate-200 text-slate-700 border-slate-400", label: "SORN" },
  unknown: { cls: "bg-slate-100 text-slate-600 border-slate-300", label: "Unknown" },
};

function Pill({ prefix, Icon, cls, label, detail, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-2.5 py-1 border-2 text-xs font-bold uppercase tracking-wide rounded ${cls}`}>
      <Icon size={14} weight="bold" />
      <span>{prefix}: {label}</span>
      {detail && <span className="font-mono normal-case font-medium opacity-90">· {detail}</span>}
    </span>
  );
}

export function MaintenanceBadge({ ms }) {
  if (!ms || !ms.status) return null;
  const m = MAINT[ms.status] || MAINT.up_to_date;
  const lim = ms.limiting;
  let detail = null;
  if (lim && lim.remaining != null && ms.status !== "up_to_date") {
    const r = Math.abs(lim.remaining);
    detail = `${r % 1 === 0 ? r : r.toFixed(0)} ${lim.unit_label} ${lim.remaining < 0 ? "over" : "left"}`;
  }
  return <Pill prefix="Maintenance" Icon={Wrench} cls={m.cls} label={m.label} detail={detail} testid={`maint-badge-${ms.status}`} />;
}

export function MotBadge({ mot, hideDate }) {
  if (!mot || !mot.required) return null;
  const m = MOT[mot.state] || MOT.unknown;
  let detail = null;
  if (mot.state === "expiring" && mot.remaining_days != null) detail = `${mot.remaining_days}d`;
  else if (!hideDate && mot.expiry && mot.state === "valid") detail = fmtDate(mot.expiry);
  return <Pill prefix="MOT" Icon={mot.state === "expired" ? WarningCircle : SealCheck} cls={m.cls} label={m.label} detail={detail} testid={`mot-badge-${mot.state}`} />;
}

export function TaxBadge({ tax }) {
  if (!tax || !tax.applicable) return null;
  const m = TAX[tax.state] || TAX.unknown;
  let detail = null;
  if (tax.state === "due_soon" && tax.remaining_days != null) detail = `${tax.remaining_days}d`;
  return <Pill prefix="Tax" Icon={tax.state === "untaxed" ? WarningCircle : ShieldCheck} cls={m.cls} label={m.label} detail={detail} testid={`tax-badge-${tax.state}`} />;
}
